<div class="container">
	<div class="body">
		<div class="logo">
			<a href="#">
				<img src="assets/media/company-logos/logo-2.png" alt="logo Fyffes">
			</a>
		</div>

		<div class="head">
			<h3>{{ 'AUTH.RESET_PASSWORD.TITLE' | translate }}</h3>
		</div>

		<kt-password-governance [isReset]="true" [userEncoded]="userEncoded"></kt-password-governance>

	</div>
</div>
